import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
      const currentUser = this.authenticationService.currentUserValue;
        const isLoggedIn = currentUser && currentUser.token;
       let apiurl=this.authenticationService.baseUrl;
        const isApiUrl = request.url.startsWith(this.authenticationService.baseUrl);
       if (isLoggedIn && isApiUrl) {
          
            request = request.clone({
                setHeaders: {                    
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
            
        }
        else{
            
        }

        return next.handle(request);
    }
}